import React, { useEffect, useState } from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { ToastContainer, toast } from 'react-toastify';
import withAuth from '../components/authHOC';
import { Card, Col } from 'react-bootstrap';
import { Alert, Button, Form, Input, InputNumber, Select, SelectProps} from 'antd';
import { IClient, IGuarantor, IIdType, ILoan, ISecurityType} from '../factory/interfaces';
import { AUTH_URL } from '../constants';
import axios from 'axios';
import { SearchOutlined } from '@ant-design/icons';
import { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { useSelector } from 'react-redux';


export  const notify = (message: string, style: any) => toast.error(message, {
        style
        })
    //Toaster
export    const toastStyle: any =  {
        background: '#ffffff',
        color: '#0a0a0a',
        fontSize: "13px",
        padding: '2px',
        position: 'bottom-center',
        fontStyle: 'bold'
      }

export const notify_success = (message: string, style: any) => toast.success(message, {
        style
        })

export interface loginCredentials{
        email: string,
        password: string
    }

const LoanTopupPage = () => {

  const [loan, setLoan]= useState<ILoan>()
  const [securityTypes, setSecurityTypes]= useState<ISecurityType[]>()
  const [idTypes, setIdTypes]= useState<IIdType[]>()
  const [form] = Form.useForm()
  const [submitting, setSubmitting] = useState(false)
  const [client, setClient]= useState<IClient>()
  const [searchIdType, setSearchIdType] = useState<string | undefined>()
  const [marchedClient, setMarchedClient]= useState<string>()
  const [searchId, setSearchId] = useState<string | undefined>()
  const [searching, setSearching]= useState(false)
  const [searchedClient, setSearchedClient]= useState(false)
  const [guarantors, setGuarantors]= useState<IGuarantor[]>([
    {name: '' , phone: '', address: ''},
    {name: '' , phone: '', address: ''}

    ])
  const [clients, setClients] = useState<SelectProps['options']>([])

  const componentRef = useRef(null);

  const handleGuarantorChange = (index: number, field: keyof IGuarantor, value: string) => {
  const newGuarantors = [...guarantors];
  newGuarantors[index][field] = value;
  setGuarantors(newGuarantors);
}
  const metadata = useSelector((state: any) => state.metadata)
 
  useEffect(() => {
    if (metadata?.data?.success) {
      setIdTypes(metadata.data.meta_data.id_types)
    }
  }, [metadata])

  //Submit

  const submit = async ()=>{

    try {
      setSubmitting(true)
    const loanData ={
      loan_id: loan?._id,
      topup_amount: loan?.topup_amount,
    }

    const response  = await axios.post(`${AUTH_URL}/finances/loans/topup`, loanData, {withCredentials: true})

    setSubmitting(false)
    if(response.data.success){
      notify_success(response.data.message, toastStyle)
      form.resetFields()
    }else{
      notify(`${response.data.message}`, toastStyle)
    }


    } catch (error: any) {
      notify(`${error.message}`, toastStyle)
      
    }
    
  }

const searchClients = (value: string, callback: Function) => {
        axios.post(`${AUTH_URL}/clients/search`, {name: value}, {withCredentials: true})
            .then((response) => {
            const data = response.data.clients.map((client: IClient) => ({
                value: client._id,
                text: `${client.surname} ${client.given_name} (${client.phone})`,
            }))
            callback(data);
            })
            .catch((error) => {
            notify(`${error.message}`, toastStyle)
            callback([])
            })
        }
  
const handleSearchClient = (newValue: string) => {
    searchClients(newValue, setClients)
  }

const handleFindLoan = async(marchedClient: string)=>{
  setSearching(true)
  const response = await axios.post(`${AUTH_URL}/finances/loans/find`, {client: marchedClient}, {withCredentials: true})
  setSearching(false)
  if(response.data.client){
    setClient(response.data.client)
  }
  if(response.data.loan){
    setLoan(response.data.loan)
  }if(!response.data.loan){
    setLoan(undefined)
  }
  if(!response.data.success){
    notify(`${response.data.message}`, toastStyle)
  }
}


useEffect(()=>{
  if(marchedClient){
  handleFindLoan(marchedClient)
  }
}, [marchedClient])

  useEffect(() => {
    if (client) {
      form.setFieldsValue({
        surname: client.surname,
        given_name: client.given_name,
        gender: client.gender,
        phone: client.phone,
        email: client.email,
        branch: client.branch,
        id_type: client.id_type,
        id_number: client.id_number
      })
    }
    if (client && loan) {
      form.setFieldsValue({
        amount: loan.amount || undefined,
        amount_to_pay: loan.amount_to_pay,
        min_installment_amount: loan.min_installment_amount,
        balance: loan.balance,
        old_payment: loan.old_payment,
        payment_amount: loan.payment_amount,
        loan_start_date: loan.loan_start_date,
        loan_end_date: loan.loan_end_date
      })
    }
  }, [client, form, loan])

  return (
    <Container ref={componentRef} fluid id='users-container'>
        <Row className=' justify-content-center py-0 g-0'>
    <ToastContainer position="top-center" className='text-capitalize'/>
        </Row>
        <Row>
        <Col>
         <Card className='p-2 rounded-0'>
                <Form
                className='p-3'
                  layout="vertical"
                  form={form}
                  name="control-hooks"
                  onFinish={submit}

                    >
                    <Row className='p-3  border'>
                    <h5>Client details</h5>
                    <Row className='align-items-center'>

                    <Col lg={12} md={12}>
                        <Form.Item
                        label="Search client"
                        name="client"
                        rules={[{ required: true, message: "Client is required" }]}
                        >
                        <Select
                          showSearch
                          placeholder="Enter client's surname, given name or phone number to search"
                          defaultActiveFirstOption={false}
                          suffixIcon={null}
                          filterOption={false}
                          onSearch={handleSearchClient}
                          notFoundContent={null}
                          options={(clients || []).map((client) => ({
                            value: client.value,
                            label: client.text,
                          }))}
                          allowClear
                          onChange={setMarchedClient}
                        />
                        </Form.Item>
                      </Col>
                    
                    
                    </Row>

                    { (marchedClient && client) &&
                    <Row style={{background: '#8888881d'}}>
                     <Col>
                     <Form.Item 
                    label="Surname" 
                    name="surname"
                    // initialValue={client.surname}
                    >
                        <Input 
                          value={client.surname}
                          readOnly
                         />
                    </Form.Item>
                    <Form.Item label="Given name"
                    name="given_name"
                    >
                        <Input
                          value={client.given_name}
                         readOnly
                        />
                    </Form.Item>
                    
                    </Col>
                    <Col>
                     
                    <Form.Item 
                    label="Gender"
                    name="gender"
                    >
                        <Input 
                          value={client.gender}
                          readOnly
                         />
                    </Form.Item>
                     <Form.Item 
                      label="Phone"
                      name="phone"
                      >
                        <Input
                          value={client.phone}
                          readOnly
                         />
                    </Form.Item>
                    
                    </Col>
                    <Col>
                    <Form.Item 
                    label="Email"
                    name="email"
                    >
                        <Input 
                          value={client.email}
                          readOnly
                         />
                    </Form.Item>
                    <Form.Item 
                    label="Branch"
                    name="branch"
                    >
                        <Input 
                          value={client.branch}
                          readOnly
                         />
                    </Form.Item>
                    
                    </Col>
                    <Col>
                      <Form.Item
                        label="Id type"
                        name="id_type"
                        >
                        <Input 
                          value={client.id_type}
                            readOnly
                          />
                      </Form.Item>
                      <Form.Item 
                      label="ID Number"
                      name="id_number"
                      >
                          <Input 
                          value={client.id_number}
                            readOnly
                          />
                      </Form.Item>
                    
                    </Col>
                    </Row>
                    }
                   
                    {
                      (loan && client && marchedClient) &&

                        <Row className='p-3 my-3 border' style={{background: '#8888881d'}}>
                    <h5>Loan & Topup details</h5>
                    <Row>

                      <Col>
                        <Form.Item
                          label="Amount Borrowed"
                          name="amount"
                          initialValue={loan?.amount}
                        >
                          <Input 
                          value={loan.amount.toString()}
                          readOnly
                            
                            />
                         </Form.Item>
                        </Col>
                        <Col>
                        <Form.Item
                          label="Total amount to pay"
                          name="amount_to_pay"
                          initialValue={loan?.amount_to_pay}                          
                        >
                          <Input 
                          value={loan.amount_to_pay.toString()}
                          readOnly
                          autoFocus
                            />
                         </Form.Item>
                        </Col>
                        <Col>
                        <Form.Item
                          label="Balance"
                          name="balance"
                        >
                          <Input
                           value={loan.balance.toString()}
                            readOnly
                            
                            />
                         </Form.Item>
                        </Col>
                        <Col>
                          <Form.Item
                            label="Start date"
                            name="loan_start_date"
                          >
                            <Input
                            value={loan.loan_start_date}
                            readOnly
                            />
                      
                          </Form.Item>
                        </Col>
                        <Col>
                           <Form.Item
                            label="End date"
                            name="loan_end_date"
                            initialValue={loan.loan_end_date}
                          >
                            <Input readOnly
                            />
                          </Form.Item>
                        </Col>
                    </Row>
                    <Row>

                    <Col>
                    
                     <Form.Item
                            label="Enter Topup amount"
                            name="topup_amount"
                            rules={[{required: true, message: 'Topup amount is required!'}]}
                            tooltip="Enter amount of money to top the current loan"
                           >
                            <InputNumber
                             style={{width: '100%'}}
                             className='rounded-0'
                                onChange={(value) => {
                                    setLoan((prevLoanData: any) => ({
                                        ...prevLoanData,
                                        topup_amount: value,
                                    }));
                                }}
                            />
                          </Form.Item>
                    </Col>
                    <Col>
                    </Col>
                    </Row>
                    </Row>
                    }
                  </Row>
                    
                    <Row>
                    <Col className='my-3'>

                     {
                      (loan && client) ? 
                      <>
                      <Button loading={submitting} type="primary" htmlType="submit" className='rounded-0 text-uppercase'>
                      {

                        submitting ?
                      'Issuing topup...' :
                      'Issue Topup'
                      }
                     </Button>
                      
                      </>
                      :
                      (!loan && client) ?

                      <Alert
                      className='rounded-0'
                        message="No active loan found"
                        description="The client selected has previously cleared all his loans or has not taken a loan yet."
                        type="info"
                        showIcon
                        closable
                      />
                      :
                      <></>
                     }
                    
                    
                    </Col>
                     
                  </Row>
                  
                </Form>
            </Card>
        
        
        </Col>
        
        </Row>
    </Container>
  )
}

export default withAuth (LoanTopupPage, ['admin', 'agent'])
